module.exports = __webpack_public_path__ + "../static/img/server-alert.a46357a0.png";